export default __webpack_public_path__ + "static/media/base-background.2dbedb92.jpg";